import React from 'react';
import SectionHeader from './SectionHeader';
import { Reveal } from './ScrollReveal';

export default function TargetAudience() {
  const targets = [
    { type: "Kreis 01", title: "Geschäftsführer & C-Level", pain: "Einsamkeit an der Spitze. Mit niemandem im Unternehmen wirklich offen sprechen. Entscheidungen, die niemand anderer treffen kann.", hook: "„Manchmal braucht man jemanden, der nicht im System steckt.\"", footer: "Im Kreis sitzen: 4 GF & Führungskräfte — aus verschiedenen Branchen. Kein Konkurrent." },
    { type: "Kreis 02", title: "Gründer & Startups", pain: "Schnell in Führungsrollen hineingewachsen, die niemand vorbereitet hat. Der Job ist plötzlich mehr Führung als Produkt — und das erwischt fast alle.", hook: "„Du weißt, was du aufbaust — aber weißt du, wer du dabei wirst?\"", footer: "Im Kreis sitzen: 4 Gründer — aus verschiedenen Branchen. Jeder versteht den Druck des anderen." },
    { type: "Kreis 03", title: "Selbstständige & Solopreneure", pain: "Alle Entscheidungen allein. Kein Board, kein Co-Founder, kein ehrliches Feedback. Gefangen zwischen Tagesgeschäft und Strategie.", hook: "„Wer gibt dir Feedback, das wirklich weh tut — aber stimmt?\"", footer: "Im Kreis sitzen: 4 Solopreneure — aus verschiedenen Branchen. Endlich Menschen, die dasselbe kennen." }
  ];

  return (
    <section id="zielgruppen" className="py-32 relative z-10 border-t border-brand-border">
      <div className="max-w-[1100px] mx-auto px-8">
        <SectionHeader 
          num="05" 
          eyebrow="Für wen — drei Kreise, drei Welten" 
          title="Gleiche Herausforderungen.<br/><em class='not-italic italic text-brand-gold'>Keine Konkurrenten.</em>" 
        />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-[1px] bg-brand-border border-2 border-brand-border shadow-2xl">
          {targets.map((target, idx) => (
            <Reveal key={idx} delay={idx * 0.1}>
              <div className="bg-brand-dark p-12 transition-colors duration-300 hover:bg-brand-surface h-full flex flex-col">
                <div className="flex justify-between items-start mb-6">
                  <div className="text-[0.7rem] font-bold tracking-[0.2em] uppercase text-brand-gold">{target.type}</div>
                  <div className="text-[0.75rem] text-brand-border2 font-bold tracking-widest uppercase">4 Plätze</div>
                </div>
                <h3 className="font-serif text-[1.7rem] font-normal text-brand-white leading-tight mb-5">{target.title}</h3>
                <p className="text-[1rem] text-brand-muted leading-relaxed mb-6 font-light">{target.pain}</p>
                <p className="font-serif text-[1.1rem] italic text-brand-gold2 leading-relaxed mb-8">"{target.hook}"</p>
                <div className="mt-auto pt-6 border-t border-brand-border text-[0.8rem] text-brand-muted2 leading-relaxed italic">
                  {target.footer}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}